export const ua = navigator.userAgent;

export const isAndroid = /(android|adr)/gi.test(ua);

export const isIOS = /(iphone|ipod|ipad)/gi.test(ua);

export const isIPad = /ipad/gi.test(ua);
export const isOpenHarmony = /OpenHarmony/gi.test(ua);

export const isMobile = isIOS || isAndroid || isOpenHarmony;
export const isKim = /Kim(.*)/.test(ua);
export const isKimAndroidMobile = isAndroid && isKim;

export const isNewKim = () =>
  Number((window as any).KIM?.kimVersion?.split('-')[1]) > 59640;

export const isMarioWebview = /MarioWebview/i.test(ua);